export enum IngredientType {
  RAW = "RAW",
  PROCESSED = "PROCESSED"
}

export enum IngredientDataType {
  SUPPLIER = "SUPPLIER",
  GENERIC = "GENERIC",
  USER = "USER",
  CALCULATED_LCA = "CALCULATED_LCA"
}

export enum IngredientDataTypeLabel {
  GENERIC = "Generic",
  SUPPLIER = "Supplier",
  USER = "User",
  CALCULATED_LCA = "Calculated LCA"
}

export enum IngredientSource {
  ALL = 0,
  BILL_OF_MATERIAL = 1,
  MAPPING_INGREDIENT = 2
}

export enum IngredientDataTypesOption {
  SPECIFIC = "SPECIFIC",
  GENERIC = "GENERIC"
}

export enum TemperatureUnitOptions {
  CELSIUS = "CELSIUS",
  FAHRENHEIT = "FAHRENHEIT"
}

export enum RecipeDataTypesOption {
  SPECIFIC = "SPECIFIC",
  GENERIC = "GENERIC",
  SEMI_SPECIFIC = "SEMI_SPECIFIC"
}

export enum RecipeIngredientType {
  OWN_PRODUCT = "OWN PRODUCT",
  GENERIC_INGREDIENT = "GENERIC INGREDIENT",
  CALCULATED_INGREDIENT = "CALCULATED INGREDIENT"
}

export enum IngredientFilterKeys {
  INGREDIENT_IDS = "currentFilterIngredientIds",
  SUPPLIER_IDS = "currentFilterSupplierIds",
  DATA_TYPE_IDS = "currentFilterDataTypeIds",
  STATUS = "ingredientCalculateStatus"
}

export enum ProcessDirectionOption {
  HEATING = "HEATING",
  COOLING = "COOLING"
}

export enum CoolingMethodOption {
  IN_LINE_COOLING = "1",
  WALK_IN_COOLER = "2",
  FORCED_AIR_BLAST = "3"
}
